module.exports = __webpack_public_path__ + "assets/img/1114f11dde50c87e4af890562c6c1a5e.png";